import { cn, tv } from "@utils/tw"
import { ReactNode, useRef, useState } from "react"
import { NavArrows } from "./NavArrows"
import { SnapScroller } from "./SnapScroller"

type Props = {
  children: ReactNode
  gridInsert?: boolean
  arrows?: boolean
  scrollerClass?: string
  className?: string
}

export function Slider(props: Props) {
  const scroller = useRef<SnapScroller>(null)
  const [canScroll, setCanScroll] = useState({ left: false, right: false })

  const styles = createStyles({ gridInset: props.gridInsert })

  return (
    <div className={cn(styles.base(), props.className)}>
      {props.arrows !== false && (
        <div className="absolute inset-0 flex items-center justify-between pointer-events-none z-[1]">
          <div className={styles.arrowsLayout()}>
            <NavArrows
              canGoLeft={canScroll.left}
              canGoRight={canScroll.right}
              onLeft={() => scroller.current?.go(-1)}
              onRight={() => scroller.current?.go(1)}
            />
          </div>
        </div>
      )}

      <SnapScroller
        scrollerRef={scroller}
        onCanScrollChange={setCanScroll}
        className={cn(styles.scroller(), props.scrollerClass)}
      >
        {props.children}
      </SnapScroller>
      {/* Click guards, to prevent clicking on masked elements */}
      {props.gridInsert && (
        <>
          <div className="absolute top-0 bottom-0 left-0 w-grid-margin-full"></div>
          <div className="absolute top-0 bottom-0 right-0 w-grid-margin-full"></div>
        </>
      )}
    </div>
  )
}

const createStyles = tv({
  base: "relative isolate scroll-mask-duration-700",
  slots: {
    arrowsLayout: "w-full relative mx-6",
    scroller: "[&>*]:snap-start scroll-mask-[60px] lg:scroll-mask-[80px]",
  },
  variants: {
    gridInset: {
      true: {
        base: "scroll-mask-inset-[calc(var(--tw-grid-margin-full)-var(--tw-grid-margin))]",
        scroller: "scroll-p-grid-margin-full",
        arrowsLayout: "w-grid mx-auto",
      },
    },
  },
})
